import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store";

import SplashScreen from "../../components/common/SplashScreen";
import { fetchSurveyAnswers } from "./store/thunk";
import useOrganization from "../organization/hooks/useOrganization";
import { useProfile } from "../auth/hooks/useProfile";

interface Props {
  children: React.ReactNode;
}

export default function SurveyBootstrap({ children }: Props) {
  const dispatch = useDispatch<AppDispatch>();
  const { currentOrganization } = useOrganization();
  const { isAuthenticated } = useProfile();
  const questionnaireId = currentOrganization?.default_survey;
  const loading = useSelector((state: RootState) => state.survey.loading);

  useEffect(() => {
    if (!isAuthenticated) return;

    if (questionnaireId) {
      dispatch(fetchSurveyAnswers(Number(questionnaireId)));
    }
  }, [dispatch, questionnaireId, isAuthenticated]);

  if (loading) {
    return <SplashScreen />;
  }

  return <>{children}</>;
}
